// extracted by mini-css-extract-plugin
export default {"base":"Di6Yb","description":"bCUcb"};